import { render, staticRenderFns } from "./ContratoPropostaTab.vue?vue&type=template&id=c5dc9924"
import script from "./ContratoPropostaTab.vue?vue&type=script&lang=js"
export * from "./ContratoPropostaTab.vue?vue&type=script&lang=js"
import style0 from "./ContratoPropostaTab.vue?vue&type=style&index=0&id=c5dc9924&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports